import React from "react";
import { View } from "react-native";
import { zodResolver } from "@hookform/resolvers/zod";
import { getSnapshot } from "mobx-state-tree";
import { FormProvider, useForm } from "react-hook-form";
import { z } from "zod";

import { RenderSpace } from "~/components/SaveForm/SaveForm.selectLocation";
import { generateObjectId } from "~/lib/utils";
import { useAccountStore } from "~/stores/space";
import { Button } from "~/ui/Button";
import { ListContainer } from "~/ui/List";

const schema = z.object({
  space: z.object({
    id: z.string(),
    collections: z.array(z.string()).optional().default([]),
  }),
});

type FormValues = z.infer<typeof schema>;

export type CopySaveFormProps = {
  srcSpaceId: string;
  saveId: string;
  onSuccess: () => void;
};

export function CopySaveForm({
  srcSpaceId,
  saveId,
  onSuccess,
}: CopySaveFormProps) {
  const {
    store: { spaceById, createSave, spacesAsArrayWithoutBacklog },
  } = useAccountStore();

  const form = useForm<FormValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      space: {
        id: "",
        collections: [],
      },
    },
  });

  const spaceWithoutSelf = spacesAsArrayWithoutBacklog.filter((space) => {
    if (space.id === srcSpaceId) return false;
    return true;
  });

  return (
    <FormProvider {...form}>
      <View className="container gap-2">
        {/* {!isSourceBacklog && (
          <ListContainer>
            <RenderSpace spaceId={store.spaceBySlug(backlogSlug)?.id ?? ""} />
          </ListContainer>
        )} */}

        {spaceWithoutSelf.length > 0 && (
          <ListContainer>
            {spaceWithoutSelf.map((space) => {
              return <RenderSpace key={space.id} spaceId={space.id} />;
            })}
          </ListContainer>
        )}
        <View />
        <View />

        <Button
          onPress={form.handleSubmit((data) => {
            const collections =
              spaceById(data.space.id)
                ?.collectionsAsArray.filter((collection) =>
                  data.space.collections?.includes(collection.id),
                )
                .map((collection) => collection.id) ?? [];

            createSave({
              spaceId: data.space.id,
              // @ts-expect-error ...
              set: {
                ...getSnapshot(spaceById(srcSpaceId)!.saveById(saveId)!),

                id: generateObjectId(),
                collections,
              },
            });

            onSuccess();
          })}
        >
          Copy selected saves
        </Button>
      </View>
    </FormProvider>
  );
}
